<template>
  <div class="modal fade modal-sms-driver" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          SMS Load Details
        </div>
        <div class="modal-body m-t-sm">

          <div class="form-group-outer">
            <div class="form-group float-label-control form-group" :class="{ 'has-error': errors.has('mobile number') }">
              <label for="">Mobile Number</label>
              <input type="email" v-model="sms.mobile" name="mobile number" class="form-control" placeholder="Mobile Number" @input="updateMobile" v-float-label v-validate="'required'">
            </div>
            <p v-if="driver" class="help-block">{{ driverName }}</p>
          </div>

          <div class="form-group float-label-control form-group" :class="{ 'has-error': errors.has('message') }">
            <label for="">Message</label>
            <textarea v-model="sms.message" v-validate="'required'" name="message" maxlength="160" class="form-control" style="resize: none" rows="8" v-float-label></textarea>
          </div>

        </div>
        <div class="modal-footer">
          <div class="row">
            <div class="col-sm-6">
              <p class="text-left m-t-sm"><em>{{ messageLength }}/160 Characters</em></p>
            </div>
            <div class="col-sm-6">
              <button type="button" class="btn btn-sm btn-default" data-dismiss="modal">Cancel</button>
                    <ladda-button :on-click="handleSendSms" type="success" size="small"><i class="fa fa-send"></i> Send</ladda-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions, mapGetters } from 'vuex'
  import { LaddaButton } from 'components/forms'
  import { notify } from 'utils'
  import { debounce, compact } from 'lodash'
  import $ from 'jquery'

  export default {
    components: {
      LaddaButton
    },

    data () {
      return {
        sms: {
          mobile: null,
          message: ''
        },
        mobile: '',
        driver: null
      }
    },

    mounted () {
      $(this.$el).on('show.bs.modal', this.resetMobileAndMessage)
    },

    beforeDestroy () {
      $(this.$el).off('show.bs.modal', this.resetMobileAndMessage)
    },

    watch: {
      mobile () {
        if (this.mobile.length > 8) {
          let payload = {
            mobile: this.mobile,
            user_id: this.load.carrier_id
          }

          this.getDrivers(payload).then(response => {
            if (response.data.data) {
              this.driver = response.data.data[0]
            } else {
              this.driver = null
            }
          })
        } else {
          this.driver = null
        }
      }
    },

    computed: {
      ...mapState('load', ['load']),

      ...mapGetters('load', ['loadDecorated']),

      messageLength () {
        return this.sms.message.length
      },

      driverName () {
        if (this.driver) {
          return `${this.driver.profile.name} ${this.driver.profile.surname}`
        }

        return ''
      }
    },

    methods: {
      ...mapActions('load', ['smsDriver']),
      ...mapActions('driver', ['getDrivers']),

      /**
       * Reset mobile and message.
       *
       * @return void
       */
      resetMobileAndMessage () {
        this.sms.mobile = this.load.driver && this.load.driver.mobile

        // Prefill the message with some of the load details.
        const locationFrom = this.load.location_from
        const locationTo = this.load.location_to
        const job = this.loadDecorated.job

        /*
        (Load Date) - (Load Size) (Commodity)
        (Location A)
        (Name) (Primary Ph) quote (Pickup Reference)
        (Location B)
        (Name) (Primary Ph) quote (Delivery Reference)
        */

        let lines = compact([
          this.load.commodity ? `${this.load.loading_date} - ${this.load.size}t ${this.load.commodity.name}` : '',
          `${locationFrom.name} ${locationFrom.suburb}: ${locationFrom.contact_phone}, ${job.pickup_reference}`,
          // `${locationFrom.latitude}, ${locationFrom.longitude}`,
          `${locationTo.name} ${locationTo.suburb}:  ${locationTo.contact_phone}, ${job.delivery_reference}`,
          // `${locationTo.latitude}, ${locationTo.longitude}`
          `Load Ref: ${this.load.reference_number}`
        ])

        this.sms.message = lines.join('\n')
      },

      /**
       * Validate and send SMS.
       *
       * @return Promise
       */
      handleSendSms () {
        const notifyFailed = () => {
          if (this.errors) {
            const errors = this.errors.errors
            for (const error in errors) {
              notify.error(errors[error].msg)
            }
          }
        }

        const notifySuccess = () => {
          notify.success('SMS Sent.')

          this.sms = {
            mobile: null,
            message: ''
          }
          this.mobile = ''
          this.driver = null

          $(this.$el).modal('hide')
        }

        let payload = {
          id: this.load.id,
          payload: this.sms
        }

        return this.validateAll().then(() => {
          return this.smsDriver(payload)
        }).then(notifySuccess).catch(notifyFailed)
      },

      /**
       * Debounce updating of mobile so we don't poll API immediately for new drivers.
       *
       * @param object event
       *
       * @return Function
       */
      updateMobile: debounce(function (event) {
        this.mobile = event.target.value
      }, 800)
    }
  }
</script>



// WEBPACK FOOTER //
// SmsModal.vue?f385ad5a